import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import { Radio } from 'semantic-ui-react';
import InputCounter from "../InputCounter/InputCounter";
import Tooltip from "../Tooltip/Tooltip";

import {
  setQuestionHeader,
  setQuestionAnswerText,
  setQuestionRole,
  //Подвопросы
  addNewSubQuestion,
  setSubQuestionHeader,
  setSubQuestionAnswerText,
  deleteSubQuestion,
} from '../../../redux/actions/editQuestion';

import "./QuestionForm.scss";

const mapDispatchToProps = dispatch => ({
  setQuestionHeader: value => dispatch(setQuestionHeader(value)),
  setQuestionAnswerText: value => dispatch(setQuestionAnswerText(value)),
  setQuestionRole: (e, { value }) => dispatch(setQuestionRole(value)),
  //Подвопросы
  addNewSubQuestion: () => dispatch(addNewSubQuestion()),
  setSubQuestionHeader: (value, subQIndex) => dispatch(setSubQuestionHeader(value, subQIndex)),
  setSubQuestionAnswerText: (value, subQIndex) => dispatch(setSubQuestionAnswerText(value, subQIndex)),
  deleteSubQuestion: subQIndex => dispatch(deleteSubQuestion(subQIndex)),
});

class QuestionForm extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    submitText: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    edit: PropTypes.bool,
    setQuestionHeader: PropTypes.func.isRequired,
    setQuestionAnswerText: PropTypes.func.isRequired,
    setQuestionRole: PropTypes.func.isRequired,
    //Подвопросы
    addNewSubQuestion: PropTypes.func.isRequired,
    setSubQuestionHeader: PropTypes.func.isRequired,
    setSubQuestionAnswerText: PropTypes.func.isRequired,
    deleteSubQuestion: PropTypes.func.isRequired,
    //Количество уже созданных вопросов разных типов
    countForClients: PropTypes.number.isRequired,
    countForConsultants: PropTypes.number.isRequired,
  };

  static defaultProps = {
    edit: false,
    countForClients: 0,
    countForConsultants: 0,
  };

  constructor() {
    super();
    this.state = {
      formWasSent: false,
      validationError: false,
      clientsTooltip: false,
      consultantsTooltip: false,
    }
  }

  renderSubQuestions = (subq, i) => {
    const {setSubQuestionHeader, setSubQuestionAnswerText, deleteSubQuestion } = this.props;
    const { formWasSent } = this.state;

    let subqHeaderErrText = '';
    if (subq.header.length === 0) subqHeaderErrText = 'Введите текст';
    if (subq.header.length > 60) subqHeaderErrText = 'Превышена максимальная длина текста';

    let subqAnswerErrText = '';
    if (subq.answer.length === 0) subqAnswerErrText = 'Введите ответ';
    if (subq.answer.length > 1000) subqAnswerErrText = 'Превышена максимальная длина ответа';

    const subqHeaderError = ((subq.header.length === 0) || (subq.header.length > 60));
    const subqAnswerError = ((subq.answer.length === 0) || (subq.answer.length > 1000));

    const subqHeaderRowClass = classnames({
      'form-row': true,
      'error': formWasSent && subqHeaderError,
    });

    const subqAnswerRowClass = classnames({
      'form-row': true,
      'error': formWasSent && subqAnswerError,
    });

    return(
      <div key={`${subq.id}_${i}`} className="subq-wrapper">
        <div className="subq-wrap">
          <div className="subq-title-wrap">
            <div className="subq-title">{`Подвопрос ${i + 1}`}</div>
            <div className="subq-btn">
              <button
                type="button"
                className="subq-btn"
                onClick={() => deleteSubQuestion(i)}
              >
                <i aria-hidden="true" className="del-icon" />
                <span>Удалить</span>
              </button>
            </div>
          </div>
          <div className={subqHeaderRowClass}>
            <InputCounter
              label={`Текст подвопроса ${i + 1}`}
              value={subq.header}
              onChange={(value) => setSubQuestionHeader(value, i)}
              maxLength={50}
            />
            {(formWasSent && subqHeaderError) ? (
              <div className="input-text">{subqHeaderErrText}</div>
            ) : false}
          </div>
          <div className={subqAnswerRowClass}>
            <InputCounter
              isTextarea
              classNameText="for-questions"
              label={`Ответ на подвопрос ${i + 1}`}
              value={subq.answer}
              onChange={(value) => setSubQuestionAnswerText(value, i)}
              maxLength={1000}
            />
            {(formWasSent && subqAnswerError) ? (
              <div className="input-text">{subqAnswerErrText}</div>
            ) : false}
          </div>
        </div>
      </div>
    );
  }

  onSubmitForm = () => {
    const { onSubmit } = this.props;
    const validationError = this.validateForm();
    this.setState({ formWasSent: true });
    if (!validationError) onSubmit();
  }

  validateForm = () => {
    const { question } = this.props;
    //Заголовок и текст родительскоро вопроса
    if (((question.header.length === 0) || (question.header.length > 50)) 
      || ((question.answer.length === 0) || (question.answer.length > 1000))) return true;
    //Заголовки подвопросов
    if ((question.children.some(child => child.header.length === 0)) 
      || (question.children.some(child => child.header.length > 50))) return true;
    //Ответы подвопросов
    if ((question.children.some(child => child.answer.length === 0)) 
      || (question.children.some(child => child.answer.length > 1000))) return true;
    //Количество подвопросов
    if (question.children.length > 50) return true;
    return false;
  }

  addSubQuestion = () => {
    const { addNewSubQuestion } = this.props;
    this.setState({ formWasSent: false });
    addNewSubQuestion();
  }

  //Тултипы
  clientsMouseEnter = () => {
    const { countForClients } = this.props;
    if (countForClients >= 5) this.setState({ clientsTooltip: true });
  }

  consultantsMouseEnter = () => {
    const { countForConsultants } = this.props;
    if (countForConsultants >= 5) this.setState({ consultantsTooltip: true });
  }

  render() {
    const {
      question,
      setQuestionHeader,
      setQuestionAnswerText,
      submitText,
      edit,
      setQuestionRole,
      countForClients,
      countForConsultants,
    } = this.props;
    const { formWasSent, clientsTooltip, consultantsTooltip } = this.state;

    const btnClass = classnames({
      'btn': true,
      'btn-green': true,
      'long': edit,
      'messages': !edit,
    });

    const headerError = ((question.header.length === 0) || (question.header.length > 50));
    const answerError = ((question.answer.length === 0) || (question.answer.length > 1000));

    const headerRowClass = classnames({
      'form-row': true,
      'error': formWasSent && headerError,
    });

    const answerRowClass = classnames({
      'form-row': true,
      'error': formWasSent && answerError,
    });

    const bottomRowClass = classnames({
      'form-row': true,
      'special': true,
      'radios': question.children.length === 0,
    });

    const rolesBlockClass = classnames({
      'roles-block': true,
      'radios': question.children.length === 0,
    });

    let headerErrorText = '';
    if (question.header.length === 0) headerErrorText = 'Введите текст вопроса';
    if (question.header.length > 50) headerErrorText = 'Превышена максимальная длина текста вопроса';

    let answerErrorText = '';
    if (question.answer.length === 0) answerErrorText = 'Введите ответ';
    if (question.answer.length > 1000) answerErrorText = 'Превышена максимальная длина ответа';

    const tooltipText = "Максимум 5 активных вопросов для создания";

    return (
      <div className="form-wrap question-form">
        {/* Текст родительского вопроса */}
        <div className={headerRowClass}>
          <InputCounter
            label="Текст вопроса"
            value={question.header}
            onChange={(value) => setQuestionHeader(value)}
            maxLength={50}
          />
          {(formWasSent && headerError) ? (
            <div className="input-text">{headerErrorText}</div>
          ) : false}
        </div>

        {/* Ответ на родительский вопрос */}
        <div className={answerRowClass}>
          <InputCounter
            isTextarea
            classNameText="for-questions"
            label="Ответ"
            value={question.answer}
            onChange={(value) => setQuestionAnswerText(value)}
            maxLength={1000}
          />
          {(formWasSent && answerError) ? (
            <div className="input-text">{answerErrorText}</div>
          ) : false}
        </div>
        
        {/* Список подвопросов */}
        <div className="subquestions-list">
          {question.children.length !== 0 ? question.children.map(this.renderSubQuestions) : false}
        </div>

        {/* Добавить подвопрос */}
        {/* Максимальное количество подвопросов - 50 */}
        <div className="form-row">
          <div className="btn-wrap">
            <button
              type="button"
              className="btn btn-add long"
              disabled={question.children.length === 50}
              onClick={() => this.addSubQuestion()}
            >
              <i aria-hidden="true" className="add-icon icon">
              <svg width="22" height="22" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"/>
              </svg>
              </i>
              <span>Добавить подвопрос</span>
            </button>
            {question.children.length === 50 ? (
              <div className="form-btn-msg">Максимум 50 подвопросв для создания</div>
            ) : false}
          </div>
        </div>

        {edit ? (
          /* Редактирование: отображение ролей вопроса */
          <div className={rolesBlockClass}>
            {question.role === 'client' ? (
              <div className="role-item clients">Для клиентов</div>
            ) : false}
            {question.role === 'consultant' ? (
              <div className="role-item consultants">Для консультантов</div>
            ) : false}
          </div>
        ) : ( 
          /* Создание: выбрать, для какой роли доступен вопрос countForClients countForConsultants */
          /* Если максимальное количество вопросов данного типа уже создано, рабиобуттон станет неактивным */
          <div className={bottomRowClass}>
            <div className="radio-wrap">
              <div
                className="radio-item-wrap"
                onMouseEnter={() => this.clientsMouseEnter()}
                onMouseLeave={() => { this.setState({ clientsTooltip: false }); }}
              >
                <Tooltip text={tooltipText} show={clientsTooltip} />
                <Radio
                  label='Для клиентов'
                  name='roleRadioGroup'
                  id="roleRadioGroup"
                  value='client'
                  checked={question.role === 'client'}
                  disabled={countForClients >= 5}
                  onChange={setQuestionRole}
                />
              </div>
              <div
                className="radio-item-wrap"
                onMouseEnter={() => this.consultantsMouseEnter() }
                onMouseLeave={() => { this.setState({ consultantsTooltip: false }); }}
              >
                <Tooltip text={tooltipText} show={consultantsTooltip} />
                <Radio
                  label='Для консультантов'
                  name='roleRadioGroup'
                  value='consultant'
                  checked={question.role === 'consultant'}
                  disabled={countForConsultants >= 5}
                  onChange={setQuestionRole}
                />
              </div>
            </div>
          </div>
        )}

        <div className="form-row special">
          <button
            type="button"
            className={btnClass}
            onClick={() => this.onSubmitForm()}
          >
            {submitText}
          </button>
        </div>
      </div>
    );
  }
}

export default connect(null, mapDispatchToProps)(QuestionForm);
